import { Injectable } from "@angular/core";
import { ServiceMeta } from "src/app/services/service-meta";

@Injectable({
    providedIn: 'root'
})
export class CustomTemplatesService {
    getPresignedPWAUrl = 'superadmin/rest/mgmt/account/preSign';
    constructor(private serviceMeta: ServiceMeta) {
    }
    getPresignedUrls(accountId) {
        return this.serviceMeta.httpPut(this.getPresignedPWAUrl + "/" + accountId);
    }
    extractFilesToUIS3(accountId) {
        const url = this.getPresignedPWAUrl + "/extract/assets/" + accountId;
        return this.serviceMeta.httpGet(url);
    }
    uploadFilesToS3(url, file) {
        return this.serviceMeta.httpPut(url, file);
    }
    getJsonFromS3(url) {
        const _this = this;
        return new Promise((resolve) => {
            _this.serviceMeta.httpGet(url).subscribe(
                (value: any) => {
                    resolve(value);
                }, () => {
                    resolve(false);
                });
        });
    }
    getTemplateJson(url) {
        const _this = this;
        return new Promise((resolve) => {
            _this.serviceMeta.httpGet(url).subscribe(
                (template: any) => {
                    resolve(template);
                }, () => {
                    resolve(false);
                });
        });
    }
    getTemplateUploadUrl(accountId) {
        const _this = this;
        return new Promise((resolve) => {
            _this.getPresignedUrls(accountId).subscribe(
                (urls) => {
                    console.log(urls);
                    resolve(urls['templateUrl']);
                }, () => {
                    resolve(false);
                }
            );
        });
    }
    publish(templateJson, accountId) {
        console.log("in publish");
        console.log(templateJson);
        this.getTemplateUploadUrl(accountId).then(
            (url) => {
                if (url) {
                    let templateFile = new File([JSON.stringify(templateJson)], 'template', { type: 'application/json', lastModified: Date.now() });
                    this.uploadFilesToS3(url, templateFile).subscribe(
                        () => {
                            console.log(accountId);
                            this.extractFilesToUIS3(accountId).subscribe(
                                (status) => {
                                    console.log(status);
                                }
                            )
                        }
                    )
                }
            }
        );
    }
}